import Swal from "sweetalert2";
import { getInstance } from "./baseapi";

const dataToken = localStorage.getItem("tokenBackoffice");
const instance = getInstance();

export const getBidding = async (queryparams) => {
    try{
        const headers = {
            Authorization: "Bearer " + dataToken,
          };
        const response = await instance.get(`/api/mgr/bidding`, {
            headers:headers,
            params: {...queryparams}
        })
        if (response.status === 200) {
            return response;
        } else {
            return null;
        }
    }catch(error) {
        Swal.fire({
            icon: "error",
            title: error,
            confirmButtonText: "OK",
        }).then((result) => {});
    }
};

export const getBiddingByID = async (id) => {
    try {
        const headers = {
            Authorization: "Bearer " + dataToken,
        };
        const response = await instance.get(`/api/mgr/bidding/${id}`, {
            headers: headers,
        });
        if (response.status === 200) {
            return await response;
        } else {
            return null;
        }
    } catch (error) {
        Swal.fire({
            icon: "error",
            title: error,
            confirmButtonText: "OK",
        }).then((result) => {});
    }
};

export const createBidding = async (body) => {
    try {
        const formData = new FormData()
        formData.append('type', body.type)
        formData.append('name_en', body.name_en)
        formData.append('name_th', body.name_th)
        formData.append('description_en', body.description_en)
        formData.append('description_th', body.description_th)
        formData.append('publish_date', body.publish_date)
        formData.append('end_date', body.end_date)
        formData.append('active', body.active)
        if (body.cover_img.length > 0) {
            if(body.cover_img[0].file?.file){
                const blob = new Blob([body.cover_img[0].file?.file], { type: body.cover_img[0].file?.file.type });
                const parts = body.cover_img[0].file?.src.split('/')
                const fileName = parts[parts.length - 1];
                const currentTime = new Date();
                const file = new File([blob], fileName, {
                    type: body.cover_img[0].file?.file.type,
                    lastModified: currentTime.getTime(),
                    lastModifiedDate: currentTime,
                    size: body.cover_img[0].file.size
                });

                formData.append('cover_img', file)
            }
            else{
                formData.append('cover_img', body.cover_img[0].file)
            }
        }
        else{
            formData.append('cover_img', null)
        }
      const headers = {
        Authorization: "Bearer " + dataToken,
      };
      for (let entry of formData.entries()) {
    }
      const response = await instance.post(`/api/mgr/bidding`, formData, {
        headers: headers,

      });
       
  
      if (response.status === 200) {
        return response;
      } else {
        return null;
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: error,
        confirmButtonText: "OK",
      }).then((result) => {});
    }
};

export const updateBiddingByID = async (id, body) => {
    try {
        const formData = new FormData()
        formData.append('type', body.type)
        formData.append('_id', body._id)
        formData.append('name_en', body.name_en)
        formData.append('name_th', body.name_th)
        formData.append('description_en', body.description_en)
        formData.append('description_th', body.description_th)
        formData.append('publish_date', body.publish_date)
        formData.append('end_date', body.end_date)
        formData.append('active', body.active)
        if (body.cover_img.length > 0) {
            if(body.cover_img[0].file?.file){
                const blob = new Blob([body.cover_img[0].file?.file], { type: body.cover_img[0].file?.file.type });
                const parts = body.cover_img[0].file?.src.split('/')
                const fileName = parts[parts.length - 1];
                const currentTime = new Date();
                const file = new File([blob], fileName, {
                    type: body.cover_img[0].file?.file.type,
                    lastModified: currentTime.getTime(),
                    lastModifiedDate: currentTime,
                    size: body.cover_img[0].file.size
                });

                formData.append('cover_img', file)
            }
            else{
                formData.append('cover_img', body.cover_img[0].file)
            }
        }
        else{
            formData.append('cover_img', null)
        }
        const headers = {
            Authorization: "Bearer " + dataToken,
        };
        const response = await instance.put(`/api/mgr/bidding/${id}`, formData, {
            headers: headers,
        });

    
        if (response.status === 200) {
            return response;
        } else {
            return null;
        }
    } catch (error) {
        Swal.fire({
            icon: "error",
            title: error,
            confirmButtonText: "OK",
        }).then((result) => {});
    }
};

export const deleteBidding = async (id) => {
    try {
      const headers = {
        Authorization: "Bearer " + dataToken,
      };
      const response = await instance.delete(`/api/mgr/bidding/${id}`, {
        headers: headers,
      });
  
      if (response.status === 200) {
        return await response;
      } else {
        return null;
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: error,
        confirmButtonText: "OK",
      }).then((result) => {});
    }
};